import React from 'react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

const IMAGE_URL = gql`
  query ImageUrl($image: String!) {
    url: mediaSignedUrl(key: $image)
  }
`

const ServerImage = ({ children, image }) => {
  return (
    <Query query={IMAGE_URL} variables={{ image }}>
      {({ loading, error, data }) => {
        if (loading) {
          return null
        }
        if (error) {
          // eslint-disable-next-line
          console.warn(error)

          return null
        }

        const { url } = data

        return children({ uri: url })
      }}
    </Query>
  )
}

export default ServerImage



// WEBPACK FOOTER //
// ./src/components/server-image.js